// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { ClipboardCheckIcon } from '@moia-dev/pace-icons'
import { ApServiceSettingsAreaRoutes } from './ApServiceSettingsAreaRoutes'

export const ApServiceSettingsAreaNavigationIcon = ClipboardCheckIcon

export const ApServiceSettingsAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={ApServiceSettingsAreaRoutes.route}
      Icon={ClipboardCheckIcon}
    />
  )
}
